import { handleToggleSubscribe } from 'APIs/utils';
import { useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';
import Loader from 'components/atoms/loader';
import { selectAuth } from 'features/auth/authSlice';
import { UserData } from 'interfaces/UserData.interface';
import React, { SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import BackstagePrompt from 'views/DesktopViews/OtherProfilePage/ProfilePageBody/BackstagePrompt';

interface ILockContentProps {
  children: JSX.Element;
  senderId: number;
  isLocked?: boolean;
  isPending?: boolean;
  transaction: boolean;
  loading: boolean;
  isSubscribed: boolean;
  user: UserData;
  setError: SetStateAction<any>;
  setTransaction: SetStateAction<any>;
  msgId: string;
  userId: number;
  setLoading: SetStateAction<any>;
  setIsSubscribed: SetStateAction<any>;
}

const LockContent = ({
  children,
  isLocked,
  isPending,
  transaction,
  isSubscribed,
  loading,
  senderId,
  setError,
  setTransaction,
  user,
  msgId,
  userId,
  setIsSubscribed,
  setLoading,
}: ILockContentProps) => {
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  return (
    <div className="image-container">
      {senderId !== authState.id && (isLocked || isPending) && (
        <span className="image-container-lock">
          <span>
            <BackstagePrompt transaction={transaction} loading={loading}>
              <NormalButton
                sx={{
                  width: '90%',
                  textTransform: 'uppercase',
                  color: 'white',
                  backgroundColor: 'rgba(0,0,0,0.4)',
                  fontSize: '10px',
                  whiteSpace: 'wrap',
                }}
                text={
                  loading ? (
                    <Loader size="2" />
                  ) : transaction || isPending ? (
                    'Waiting on block chain transaction'
                  ) : (
                    ' Unlock For 0.2 ETH'
                  )
                }
                onClick={() =>
                  handleToggleSubscribe(
                    authState,
                    setError,
                    setTransaction,
                    setLoading,
                    setIsSubscribed,
                    dispatch,
                    false,
                    '0.00012',
                    user,
                    undefined,
                    msgId,
                    authState.id,
                    userId
                  )
                }
                isDisabled={isSubscribed || transaction || loading}
              />
            </BackstagePrompt>
          </span>
        </span>
      )}
      {children}
    </div>
  );
};

export default LockContent;
